import { render, staticRenderFns } from "./poisson.vue?vue&type=template&id=65ac71be&"
import script from "./poisson.vue?vue&type=script&lang=js&"
export * from "./poisson.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports